// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.login-form[data-v-46b35b01] {\n    min-height: 100vh;\n    width: 100%;\n    padding-top: 52px;\n    background: #f4f6f9;\n}\n", ""]);
// Exports
module.exports = exports;
